import { Link } from "react-router-dom";
import { Ellipsis, UserPlus, UserRoundCheck } from "lucide-react";

import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

// Row actions for the Meta leads table. The contact action routes to the
// existing contact when one exists, otherwise to the lead's create-contact
// route, which links the new contact back to this Meta lead.
export function MetaLeadsTableActions({ original, accountId }) {
  const { id, contact_id } = original;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label="Lead actions"
        className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
      >
        <Ellipsis />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {contact_id ? (
          <DropdownMenuItem render={<Link to={`/contacts/${contact_id}`} />}>
            <UserRoundCheck />
            View Contact
          </DropdownMenuItem>
        ) : (
          <DropdownMenuItem
            render={<Link to={`/leads/meta/${accountId}/lead/${id}/contact`} />}
          >
            <UserPlus />
            Create Contact
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
